/** Margen para el redondeo subpíxel de `scrollLeft` en pantallas con zoom o DPR fraccional. */
const TOLERANCIA_PX = 1;

/** true si un contenedor con scroll horizontal tiene contenido oculto a la derecha. */
export function hayMasALaDerecha(
  scrollLeft: number,
  clientWidth: number,
  scrollWidth: number,
): boolean {
  return scrollLeft + clientWidth < scrollWidth - TOLERANCIA_PX;
}

/**
 * `scrollLeft` que deja un elemento entero a la vista dentro del contenedor
 * (equivalente a `inline: 'nearest'`), o null si ya se ve completo.
 * `inicio` es la posición del elemento medida desde el borde del contenido desplazable.
 */
export function scrollParaMostrar(
  inicio: number,
  ancho: number,
  scrollLeft: number,
  clientWidth: number,
): number | null {
  const fin = inicio + ancho;
  if (inicio < scrollLeft) return Math.max(0, inicio);
  if (fin > scrollLeft + clientWidth) {
    return ancho >= clientWidth ? Math.max(0, inicio) : fin - clientWidth;
  }
  return null;
}
